var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 5.62506C3.375 4.38242 4.38236 3.37506 5.625 3.37506H21.375C22.6176 3.37506 23.625 4.38242 23.625 5.62506V21.3751C23.625 22.6177 22.6176 23.6251 21.375 23.6251H5.625C4.38236 23.6251 3.375 22.6177 3.375 21.3751V5.62506Z",
    stroke: "var(--mainColor)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61523 6.18756H8.03273",
    stroke: "var(--mainColor)",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6514 6.18756L17.3982 6.18756",
    stroke: "var(--mainColor)",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7393 6.18756L20.4861 6.18756",
    stroke: "var(--mainColor)",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 9.00006L23.625 9.00006",
    stroke: "var(--mainColor)",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.3126H15.0057",
    stroke: "var(--mainColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.3126C9 12.9147 9.15804 12.5332 9.43934 12.2519C9.72064 11.9706 10.1022 11.8126 10.5 11.8126H16.5C16.8978 11.8126 17.2794 11.9706 17.5607 12.2519C17.842 12.5332 18 12.9147 18 13.3126V19.3126C18 19.7104 17.842 20.0919 17.5607 20.3732C17.2794 20.6545 16.8978 20.8126 16.5 20.8126H10.5C10.1022 20.8126 9.72064 20.6545 9.43934 20.3732C9.15804 20.0919 9 19.7104 9 19.3126V13.3126Z",
    stroke: "var(--mainColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18.3125L11.5 15.8125C11.964 15.366 12.536 15.366 13 15.8125L15.5 18.3125",
    stroke: "var(--mainColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17.3125L15 16.8125C15.464 16.366 16.036 16.366 16.5 16.8125L18 18.3125",
    stroke: "var(--mainColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostsIcon);
export default __webpack_public_path__ + "static/media/postsIcon.0fbd60298f9332780db19c0aaa657a54.svg";
export { ForwardRef as ReactComponent };